import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#009e9a',
    },
    secondary: {
      main: '#00C9BE',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
  typography: {
   "fontFamily": "Nunito",
  },
  h4: {
   "fontFamily": "Nunito",
  }
});

export default theme;
